<template>
	<div>
		<div v-if="actions.length > 0">
			<b-container style="margin: 0; padding: 0; max-width: none">
				<b-row>
					<b-col cols="">
						<h1 v-if="!minimal">Actions à réaliser</h1>
						<p>
							<b-button v-if="nb > 1" v-on:click="changeAction(-1)" variant="link"><i class="fas fa-arrow-circle-left"></i></b-button>
							{{nb}}/{{actions.length}} 
							<b-button v-if="nb < actions.length" v-on:click="changeAction(1)" variant="link"><i class="fas fa-arrow-circle-right"></i></b-button>
						</p>
					</b-col>
					<b-col v-if="!minimal" cols="6" style="margin-top:-40px">
						<b-card v-if="notifications.length > 0">
							<div v-for="(notification, idx) in notifications.slice(0, 3)" :key="idx">
								{{moment.utc(notification.date).local().fromNow()}} : {{notification.data.text}} <b-button @click="delete_notifications(notification.uid)" variant="link" size="sm"><i style="color:red" class="fas fa-trash"></i></b-button>
							</div>
							<b-modal
								:hide-footer="true"
								size="lg"
								:id="'notifs-'+id"
								:title="'Notifications'">
									<div v-for="(notification, idx) in notifications" :key="idx">
										{{moment(notification.date).fromNow()}} : {{notification.data.text}} <b-button @click="delete_notifications(notification.uid)" variant="link" size="sm"><i style="color:red" class="fas fa-trash"></i></b-button>
									</div>
							</b-modal>
							<b-button v-b-modal="'notifs-'+id" variant="link" size="sm">Voir les {{notifications.length}} notifications</b-button>
						</b-card>
					</b-col>
				</b-row>
			</b-container>
			<b-tabs>
				<b-tab :title="name">
					<formulaire v-if="type == 'formulaire'" :uid="element" @done="done_action"></formulaire>
					<div v-if="type == 'signature'">
						<signature :options="element"></signature>
					</div>
					<div v-if="type == 'validation'">
						<validate :options="element" :data="action" :default_project="params.project_validate" @done="done_action"></validate>
					</div>
				</b-tab>
				<b-tab title="Aide" v-if='help[name] || help[type]'>
					<div v-html="help[name] ? help[name].text : help[type].text"></div>
				</b-tab>
			</b-tabs>
		</div>
		<div v-else>
			<h1>Actions à réaliser</h1>
			<p>Vous n'avez pas d'actions à réaliser.</p>
			<div v-if="last">
				Dernière action faite le {{ [last.date] | moment('LLL')}} de type {{ last.action }} : {{ last.name }}
			</div>
			<br />
			<b-card>
				<div v-for="(notification, idx) in notifications" :key="idx">
					{{moment.utc(notification.date).local().fromNow()}} : {{notification.data.text}} <b-button @click="delete_notifications(notification.uid)" variant="link" size="sm"><i style="color:red" class="fas fa-trash"></i></b-button>
				</div>
			</b-card>
		</div>

	</div>
</template>

<script>
	import store from "../store";

	import uniqueId from "lodash.uniqueid";
	import users from "../services/users.js";
	import client from "../services/client.js";
	import formulaire from "../components/form.vue";
	import viewFile from "../components/viewFile.vue";
	import validate from "../components/validate.vue";
	import signature from "../components/signature.vue";
	import userActions from "../services/userActions.js";
	import messages_services from "../services/messages.js";
	
	var clone = require("clone");

	export default {
		name: "actions",
		components: {
			formulaire,
			viewFile,
			validate,
			signature
		},
		props: {
			minimal: {
				default: false
			}
		},
		data() {
			return {
				id: uniqueId(""),

				table: "",
				actions: [],
				params: {},
				nb: 1,
				help: {},

				action: {},
				name: "",
				type: "",
				element: "",
				last: null,

				notifications: [],
				timer: null
			};
		},
		computed: {
			event() {
				return this.$store.getters.getEvent
			}
		},
		watch: {
			event: async function (event) {
				console.log(event)
				if (event.type == "notifications" || event.type == "notification")
				{
					this.notifications = [];
					this.notifications = await messages_services.list("notification")
					this.notifications = this.notifications.messages

					for (var i = 0; i < this.notifications.length; i++)
					{
						this.notifications[i].data = JSON.parse(this.notifications[i].data)
					}
				}
				if (event.type == "actions" || event.type == "action")
				{
					var data = JSON.parse(event.data);

					if (event.action == "insert" || (event.action == "update" && data.new.hasOwnProperty("active") && data.new.active > 0))
					{
						var actions = await userActions.get("SELECT", this.table, {
							where: '`id` = ' + event.id_data
						}, false);

						console.log(actions)

						this.actions.push(actions[0]);

						if (this.actions.length == 1)
						{
							this.changeAction(0);
						}
					}
					if (event.action == "delete" || (event.action == "update" && data.new.hasOwnProperty("active") && data.new.active <= 0))
					{
						for (var i = 0; i < this.actions.length; i++)
						{
							if (this.actions[i].id == event.id_data)
							{
								this.actions.splice(i, 1);
								if (i + 1 < this.nb)
									this.nb--;
								else if (i + 1 == this.nb)
								{
									await this.changeAction(this.nb == 1 ? 0 : -1);
								}
								i--;
							}
						}
						if (this.actions.length == 0)
						{
							this.nb == 1;

							this.last = await userActions.get("SELECT", this.table, {
								where: "`" + this.params.column_date + '` is not null and `' + this.params.column_active + '`' + " = 0 or `" + this.params.column_active + '`' + " = -1 ORDER BY `" + this.params.column_date + "` DESC limit 1"
							}, true);

							if (this.last.length > 0)
							{
								this.last = this.last[0];
								this.last.date = this.last[this.params.column_date];
							}
							else
								this.last = null;
						}
					}
				}
			}
		},
		methods: {
			async delete_notifications(uid)
			{
				console.log("delete_notifications " + uid)
				for (var i = 0; i < this.notifications.length; i++)
                {
                    if (this.notifications[i].uid == uid)
                    {
						console.log(this.notifications[i])
                        await messages_services.delete(this.notifications[i].uid)
                        this.notifications.splice(i, 1);
                        i--;
                    }
                }
			},
			async done_action()
			{
				console.log("done_action");

				console.log(this.action)

				if (this.action.active != 2)
				{
					console.log("unactive");
					var response = await userActions.get(
						"update",
						this.table,
						{
							set: '`' + this.params.column_active + '` = 0',
							where: 'id = ' + this.action.id,
						},
						false
					);

					var nb = 0;
					this.actions.splice(this.nb - 1, 1);
					if (this.nb > this.actions.length && this.nb > 0)
						nb = -1;
					await this.changeAction(nb)
				}
				else
					await this.changeAction(0)

				if (this.action[this.params.column_action] == "validation" && this.params.column_notification && this.action[this.params.column_notification])
				{
					await messages_services.post("", null, this.action[this.params.column_notification], "notification");
				}

			},
			async changeAction(nb = 0)
			{
				var self = this;
				this.action = {};
				this.type = null;

				this.$nextTick(async function () {
					if (self.actions && self.actions.length > 0)
					{
						self.nb += nb;
						self.action = self.actions[self.nb - 1];
						self.name = self.action[self.params.column_name];
						self.type = self.action[self.params.column_action];
						self.element = self.action[self.params.column_element];
					}
					else
					{
						self.last = await userActions.get("SELECT", self.table, {
							where: "`" + self.params.column_date + '` is not null and `' + self.params.column_active + '`' + " = 0 or `" + self.params.column_active + '`' + " = -1 ORDER BY `" + self.params.column_date + "` DESC limit 1"
						}, true);

						if (self.last && self.last.length > 0)
						{
							self.last = self.last[0];
							self.last.date = self.last[self.params.column_date];
						}
						else
							self.last = null;
					}
				});
			}
		},
		mounted: async function () {
			var self = this;

			if (
				store.state.user.rules &&
				!store.state.user.rules.actions
			) {
				this.$router.push({ name: "profile" });
			}

			let response = await users.getSelf(true);
			this.params = response.client.details.actions;
			this.help = this.params.help || {};

			this.table = this.params.table;

			var actions = await userActions.get("SELECT", this.table, {
				where: '`' + this.params.column_active + '`' + " > 0 ORDER BY " + (this.params.column_priority ? this.params.column_priority + " DESC, " : "") + " id ASC"
			}, false);

			if (actions)
			{
				this.actions = actions;
				await this.changeAction()
			}

			this.last = await userActions.get("SELECT", this.table, {
				where: "`" + this.params.column_date + '` is not null and (`' + this.params.column_active + '`' + " = 0 or `" + this.params.column_active + '`' + " = -1) ORDER BY `" + this.params.column_date + "` DESC limit 1"
			}, true);

			if (this.last && this.last.length > 0)
			{
				this.last = this.last[0];
				this.last.date = this.last[this.params.column_date];
			}
			else
				this.last = null;

			this.notifications = await messages_services.list("notification")
			if (this.notifications && this.notifications.messages)
			{
				this.notifications = this.notifications.messages

				for (var i = 0; i < this.notifications.length; i++)
				{
					this.notifications[i].data = JSON.parse(this.notifications[i].data)
				}
			}
			else
			{
				this.notifications = []
			}

			 this.timer = setInterval(() => {10
				var notifications = clone(self.notifications);
				self.notifications = [];
				self.notifications = notifications;

			}, 60000)

		},
		beforeDestroy() {
			clearInterval(this.timer)
		}
	};
</script>
